var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57976 1.1665C2.33868 1.1665 2.12243 1.31481 2.03559 1.53971L1.15974 3.80788L1.15974 3.80788C0.791333 4.76195 1.09087 5.75791 1.76254 6.37834C1.76172 6.39096 1.76131 6.40368 1.76131 6.4165V12.2498C1.76131 12.572 2.02247 12.8332 2.34464 12.8332H11.678C12.0002 12.8332 12.2613 12.572 12.2613 12.2498V6.4165C12.2613 6.40351 12.2609 6.39062 12.2601 6.37783C12.9319 5.75715 13.2316 4.76094 12.8629 3.80656L12.8629 3.80655L11.9872 1.53963C11.9003 1.31477 11.6841 1.1665 11.4431 1.1665H2.57976ZM2.92797 6.96141C3.06633 6.98661 3.20955 6.99984 3.35675 6.99984C4.05347 6.99984 4.68156 6.69405 5.11096 6.20859C5.53854 6.69376 6.16459 6.99984 6.86212 6.99984H7.15915C7.85672 6.99984 8.4828 6.69373 8.91038 6.20851C9.3399 6.69403 9.96813 6.99984 10.6648 6.99984C10.8124 6.99984 10.956 6.98654 11.0947 6.96123V11.6665H2.92797V6.96141Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.20a8b86aa83d5efa48ea8461d0c12cd2.svg";
export { ForwardRef as ReactComponent };